// extracted by mini-css-extract-plugin
export default {"socialIcons":"SocialIcons_socialIcons__ukGzZ"};